import { ShortDriver } from '@allocab/allocab-driver-shared-types';
import { useState } from 'react';

import { usePatchVehicleForDriver } from '../../hooks/usePatchVehicleForDriver';
import { ToastManager } from '../../services/toast/utils';
import { t } from '../../services/translation/translation';
import { getFullName, noop } from '../../utils/common';
import { GradientButton } from '../button/GradientButton';
import { SecondaryButton } from '../button/SecondaryButton';
import { Modal } from '../modal/Modal';

type Props = {
  onClose: () => void;
  drivers: ShortDriver[];
  vehicleId: string;
};

export const VehicleAssignModal = ({ onClose, drivers, vehicleId }: Props) => {
  const [selectedDriver, setSelectedDriver] = useState<ShortDriver>(drivers[0]);
  const { mutate: assignVehicle, isLoading } = usePatchVehicleForDriver();

  const handleClose = isLoading ? noop : onClose;

  const handleAssign = () => {
    assignVehicle(
      { driverId: selectedDriver.id, vehicleId },
      {
        onSuccess: () => {
          onClose();
          ToastManager.show({
            severity: 'success',
            message: t('vehicles-route.assign-modal.success', {
              fullName: getFullName(selectedDriver.firstName, selectedDriver.lastName),
            }),
          });
        },
      },
    );
  };

  return (
    <Modal onClose={handleClose}>
      <Modal.Header onClose={handleClose} title={t('vehicles-route.assign-modal.title')} />
      <Modal.Body>
        <p className="text-sm font-normal text-gray-500 dark:text-gray-400">
          {t('vehicles-route.assign-modal.description')}
        </p>

        <div className="w-full bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-800 dark:divide-gray-600 max-h-40 overflow-y-auto mt-4">
          <ul
            className="p-3 space-y-1 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownRadioBgHoverButton"
          >
            {drivers.map(driver => (
              <li key={driver.id}>
                <div className="flex items-center pl-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer">
                  <input
                    id={`assign-radio-${driver.id}`}
                    type="radio"
                    checked={driver.id === selectedDriver?.id}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer"
                    onChange={() => setSelectedDriver(driver)}
                  />
                  <label
                    htmlFor={`assign-radio-${driver.id}`}
                    className="w-full ml-2 p-2 text-sm font-medium text-gray-900 rounded dark:text-gray-300 cursor-pointer"
                  >
                    {getFullName(driver.firstName, driver.lastName)}
                  </label>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <GradientButton onClick={handleAssign} isLoading={isLoading}>
          {t('common.assign')}
        </GradientButton>
        <SecondaryButton onClick={handleClose}>{t('common.cancel')}</SecondaryButton>
      </Modal.Footer>
    </Modal>
  );
};
